var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8134 6.08759C18.8726 6.02843 18.9195 5.9582 18.9515 5.8809C18.9835 5.8036 19 5.72076 19 5.63709C19 5.55343 18.9835 5.47058 18.9515 5.39329C18.9195 5.31599 18.8726 5.24576 18.8134 5.1866C18.7542 5.12744 18.684 5.08051 18.6067 5.0485C18.5294 5.01648 18.4466 5 18.3629 5C18.2792 5 18.1964 5.01648 18.1191 5.0485C18.0418 5.08051 17.9716 5.12744 17.9124 5.1866L12 11.1003L6.08759 5.1866C6.02843 5.12744 5.9582 5.08051 5.8809 5.0485C5.8036 5.01648 5.72076 5 5.63709 5C5.55343 5 5.47058 5.01648 5.39329 5.0485C5.31599 5.08051 5.24576 5.12744 5.1866 5.1866C5.12744 5.24576 5.08051 5.31599 5.0485 5.39329C5.01648 5.47058 5 5.55343 5 5.63709C5 5.72076 5.01648 5.8036 5.0485 5.8809C5.08051 5.9582 5.12744 6.02843 5.1866 6.08759L11.1003 12L5.1866 17.9124C5.06712 18.0319 5 18.1939 5 18.3629C5 18.5319 5.06712 18.6939 5.1866 18.8134C5.30608 18.9329 5.46813 19 5.63709 19C5.80606 19 5.96811 18.9329 6.08759 18.8134L12 12.8997L17.9124 18.8134C18.0319 18.9329 18.1939 19 18.3629 19C18.5319 19 18.6939 18.9329 18.8134 18.8134C18.9329 18.6939 19 18.5319 19 18.3629C19 18.1939 18.9329 18.0319 18.8134 17.9124L12.8997 12L18.8134 6.08759Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.382987724cb26d88340e12a9440e70b6.svg";
export { ForwardRef as ReactComponent };